import React, { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Platform } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

/**
 * Collapsible picker: choose one admin user email (from getNotificationPreferences.adminUsers).
 */
export default function AdminEmailDropdown({ adminUsers, value, onChange, placeholder, disabled }) {
  const [open, setOpen] = useState(false);
  if (!adminUsers?.length) {
    return <Text style={styles.emptyAdmin}>No admin users found</Text>;
  }
  const selected = adminUsers.find((u) => u.email === value);
  const label = selected
    ? selected.displayName && selected.displayName !== selected.email
      ? `${selected.email} (${selected.displayName})`
      : selected.email
    : placeholder || 'Select admin';

  return (
    <View style={styles.dropdownWrap}>
      <TouchableOpacity
        style={[styles.dropdownHeader, disabled && styles.dropdownHeaderDisabled]}
        onPress={() => !disabled && setOpen((o) => !o)}
        activeOpacity={0.8}
        disabled={disabled}
      >
        <Text style={styles.dropdownHeaderText} numberOfLines={1}>
          {label}
        </Text>
        <Ionicons name={open ? 'chevron-up' : 'chevron-down'} size={20} color="#94A3B8" />
      </TouchableOpacity>
      {open && (
        <View style={styles.dropdownList}>
          {adminUsers.map((u) => {
            const isSel = u.email === value;
            return (
              <TouchableOpacity
                key={u.id}
                style={[styles.dropdownItem, isSel && styles.dropdownItemSelected]}
                onPress={() => {
                  onChange(u.email);
                  setOpen(false);
                }}
              >
                <Text style={styles.dropdownItemText}>{u.email}</Text>
                {u.displayName && u.displayName !== u.email ? (
                  <Text style={styles.dropdownItemSub}>{u.displayName}</Text>
                ) : null}
              </TouchableOpacity>
            );
          })}
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  emptyAdmin: {
    color: '#64748B',
    fontSize: 14,
    textAlign: 'center',
    padding: 16,
  },
  dropdownWrap: {
    marginBottom: 4,
    zIndex: 1,
  },
  dropdownHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#0F172A',
    borderRadius: 8,
    paddingHorizontal: 14,
    paddingVertical: 12,
    borderWidth: 1,
    borderColor: '#334155',
  },
  dropdownHeaderDisabled: {
    opacity: 0.6,
  },
  dropdownHeaderText: {
    flex: 1,
    color: '#FFFFFF',
    fontSize: 14,
    marginRight: 8,
  },
  dropdownList: {
    marginTop: 4,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#334155',
    backgroundColor: '#0F172A',
    overflow: 'hidden',
    ...(Platform.OS === 'web' ? { boxShadow: '0 8px 24px rgba(0,0,0,0.35)' } : {}),
  },
  dropdownItem: {
    paddingHorizontal: 14,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#1E293B',
  },
  dropdownItemSelected: {
    backgroundColor: '#8B5CF620',
  },
  dropdownItemText: {
    color: '#FFFFFF',
    fontSize: 14,
    fontWeight: '500',
  },
  dropdownItemSub: {
    color: '#64748B',
    fontSize: 12,
    marginTop: 2,
  },
});
